export default "__VITE_PUBLIC_ASSET__08672066__"